// Import trademark classes from the generated JSON file
import trademarkClassesData from './trademarkClasses.json';

// Export the classes data
export const trademarkClasses = trademarkClassesData;

// Function to search trademark classes
export const searchTrademarkClasses = (searchTerm) => {
  if (!searchTerm || searchTerm.trim() === '') {
    return trademarkClasses; // Return all classes when no search term
  }
  
  const term = searchTerm.toLowerCase().trim();
  const searchWords = term.split(/\s+/).filter(word => word.length > 0);
  
  return trademarkClasses.filter(cls => {
    // Check class number
    if (cls.number.toString().includes(term)) {
      return true;
    }
    
    // Check name
    const name = cls.name.toLowerCase();
    if (name.includes(term)) {
      return true;
    }
    
    // Check description with partial word matching
    const description = cls.description.toLowerCase();
    
    // If single word search, use simple includes
    if (searchWords.length === 1) {
      return description.includes(term);
    }
    
    // For multiple words, check if all words are present in description
    return searchWords.every(word => description.includes(word));
  });
};

// Function to get class by number
export const getClassByNumber = (number) => {
  return trademarkClasses.find(cls => cls.number === parseInt(number));
};

// Function to get unique class numbers (since we have multiple entries per class)
export const getUniqueClasses = () => {
  const uniqueMap = new Map();
  trademarkClasses.forEach(cls => {
    if (!uniqueMap.has(cls.number)) {
      uniqueMap.set(cls.number, cls);
    }
  });
  return Array.from(uniqueMap.values()).sort((a, b) => a.number - b.number);
};

// Function to get all descriptions for a specific class number
export const getClassDescriptions = (classNumber) => {
  return trademarkClasses.filter(cls => cls.number === parseInt(classNumber));
}; 